import React from "react";
import './index.css'

const CustomButton = ({Icon, title, handleEnableInput})=>{
    return(
            <div onClick={handleEnableInput} className="custom-button-container" >
                {Icon}
                <p style={{marginLeft:'10px'}}>{title}</p>
            </div>
    )
}

export default CustomButton